
<div class="document-section">
  <h5 class="document-title"  *ngIf="!isPreviewMode">
    <i class="fas fa-file-upload"></i>
    {{ config.title }}
  </h5>
  <p class="document-description"  *ngIf="!isPreviewMode">
    {{ config.description }}
  </p>
  
  <!-- Document Upload Area -->
  <div class="upload-area" *ngIf="!isPreviewMode">
    <input
      type="file"
      #documentInput
      (change)="onFileSelected($event)"
      [accept]="config.acceptedFormats"
      style="display: none;"
    />
    <button
      type="button"
      class="btn btn-outline-primary upload-btn"
      (click)="documentInput.click()"
      *ngIf="!hasDocument()"
    >
      <i class="fas fa-plus"></i>
      {{ config.uploadButtonText }}
    </button>
  </div>



  <!-- Document Display Table -->
  <div class="document-table" *ngIf="documents.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Document Type</th>
          <th>File Name</th>
          <th  *ngIf="!isPreviewMode">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let doc of documents">
          <td>
            <span class="document-type-badge">
              {{ config.documentTypeLabel }}
            </span>
          </td>
          <td>
            <a 
              href="javascript:void(0)" 
              (click)="downloadDocument(doc)"
              class="document-link"
            >
              <i class="fas fa-file"></i>
              {{ doc.DocName || doc.DocName || 'Document' }}
            </a>
          </td>
          <td  *ngIf="!isPreviewMode">
            <button
              type="button"
              class="btn btn-sm btn-danger delete-btn"
              (click)="deleteDocument(doc.Id || doc.id, doc.FileName || doc.fileName)"
              title="Delete Document"
             
            >
              <i class="fas fa-trash"></i>
            </button>
           
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Documents Message -->
  <div class="no-documents" *ngIf="documents.length === 0">
    <p class="text-muted">No documents uploaded yet.</p>
  </div>

  <!-- Document Validation Error Message -->
  <div *ngIf="showValidationError && !isValid() && !isPreviewMode" class="alert alert-danger mt-3">
    <i class="fas fa-exclamation-triangle"></i>
    <strong>{{ config.validationErrorTitle }}:</strong> {{ config.validationErrorMessage }}
  </div>
</div>